export const MAX_DICTATION_SESSION_SECONDS = 300;

export const DICTATION_TOKENS_PER_AUTHOR_PER_HOUR = 300;
export const DICTATION_ORGANIZE_PER_AUTHOR_PER_HOUR = 120;
export const DICTATION_LOCAL_REQUESTS_PER_HOUR = 500;
